import { useQuery } from '@tanstack/react-query';

import { useListagemContext } from 'context/ListagemContext';
import { RequestListagem, useRequestListagem } from 'hooks/useRequestListagem';
import { ConfiguracaoPedidoCompraList } from 'pages/compra/configuracao-pedido/types';

export function useQueryConfigPedido() {
    const { filter, limit, page, sort, autoLoad } = useListagemContext();
    const requestListagem = useRequestListagem();

    return useQuery<RequestListagem<ConfiguracaoPedidoCompraList[]>>({
        enabled: autoLoad,
        queryKey: ['config-pedido', filter, limit, page, sort],
        queryFn: () =>
            requestListagem({
                url: '/gestao/configpedido',
                sort: sort.length ? sort : [{ property: 'idConfigPedido', direction: 'DESC' }],
                nested: false,
                filter,
                limit,
                page,
            }).then((data) => data.data),
    });
}
